const isAngelAi = (domain) => domain === "angelai";

const DEFAULT_KEYWORDS = "Interest Rates, Real Estate Data, Real Estate Listings, Home Sales, Home Inventory, Home Price Forecasts, Mortgage Loans, Loan Products, FHA Loans, Roofing Trends, Mortgage Industry, Industry Trends, Insider Knowledge, Expert Analysis, Mortgage Market, Mortgage Game, Mortgage Success, Mortgage Resources, Mortgage Insights, Mortgage Newsletter, Newsletter, Sun West Mortgage, Masterminds, Sun West, Ai, Chat, Bot, AngelAi, Break Free, Underwriter in Your Pocket, Pocket Underwriter, Underwriter at Your Fingertips, AngelAi.Ai, Quick Underwriting, Ask AngelAi, Assistant, Empathetic Technology, 24/7, Mortgage, Loan, Underwriter, Loan Assistant, Homebuying, Homebuyer, Home Loan, Real Estate, Real Estate Deals, Loan Originator, Loan Officer, Lender, Divorce Your Processor, Loan KeepingTM, Instant UnderwritingTM, Realtor\u00ae, Mortgage Technology, Blockchain Technology, TRU Approval\u00ae, The Processor, Low Rates, Mortgage Possible, Homebuyer Connect, Wholesale, Correspondent, Faster Conditions, Quick Turn Times, Realtor\u00ae, Loan originator, Loan officer, Mortgage newsletter service, Monthly mortgage newsletter, Mortgage news letters, Mortgage industry newsletter.";

function getDefaults(domain, cdnLink) {
  const brand = isAngelAi(domain) ? "AngelAi" : "Sun West";
  return {
    title: `${brand} Masterminds: The Newsletter for Industry Leaders`,
    description: `Discover the latest developments in the mortgage industry with ${brand} Masterminds newsletter - the must-read for industry leaders.`,
    thumbnail: `${cdnLink}mastermind/homepage/Masterminds.jpg`,
    keywords: DEFAULT_KEYWORDS,
  };
}

function getMetaTags({ pageType, editionName, personName, personData, metaData, domain, cdnLink, publicUrl }) {
  const baseUrl = publicUrl?.endsWith("/") ? publicUrl : `${publicUrl}/`;
  const defaults = getDefaults(domain, cdnLink);
  const displayName = personData?.name || personData?.loanOfficer?.name || personName;
  const angelai = isAngelAi(domain);

  // Edition JSON meta with fallbacks
  const editionTitle = metaData?.title || defaults.title;
  const editionDesc = metaData?.description || defaults.description;
  const editionThumb = metaData?.thumbnail || defaults.thumbnail;
  const editionKeywords = metaData?.keywords || defaults.keywords;

  // MLO page
  if (pageType === "mlo" && displayName) {
    const thumbnail = angelai
      ? `${cdnLink}mastermind/angelai/MLO/${editionName}/thumbnail.jpg`
      : `${cdnLink}mastermind/MLO/${editionName}/thumbnail.jpg`;
    return {
      title: `${editionTitle} - ${displayName}`,
      description: `${editionDesc.replace(/\.$/, "")} featuring ${displayName}.`,
      thumbnail,
      url: `${baseUrl}${personName}/${editionName}`,
      keywords: editionKeywords,
    };
  }

  // Influencer page
  if (pageType === "influencer" && displayName) {
    const thumbnail = angelai
      ? `${cdnLink}mastermind/angelai/influencer/${editionName}/${(personName || "").toLowerCase()}-thumbnail.jpg`
      : `${cdnLink}mastermind/MLO/${editionName}/thumbnail.jpg`;
    return {
      title: `${editionTitle} - ${displayName}`,
      description: `${editionDesc.replace(/\.$/, "")} featuring ${displayName}.`,
      thumbnail,
      url: `${baseUrl}${personName}/${editionName}`,
      keywords: editionKeywords,
    };
  }

  // Edition (main) page
  if (pageType === "edition") {
    const editionThumbnail = editionThumb !== defaults.thumbnail
      ? editionThumb
      : (angelai
        ? `${cdnLink}mastermind/angelai/${editionName}/thumbnail.jpg`
        : editionThumb);
    return {
      title: editionTitle,
      description: editionDesc,
      thumbnail: editionThumbnail,
      url: metaData?.url || `${baseUrl}${editionName}`,
      keywords: editionKeywords,
    };
  }

  // Homepage — hardcoded defaults
  return {
    title: defaults.title,
    description: defaults.description,
    thumbnail: angelai
      ? `${cdnLink}mastermind/homepage/angelai-masterminds.jpg`
      : defaults.thumbnail,
    url: baseUrl,
    keywords: defaults.keywords,
  };
}

export { getMetaTags, getDefaults, DEFAULT_KEYWORDS };
